import React from "react";
import { Link } from "react-router-dom";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function StatsCard({
  label, value, icon: Icon, trend, hint, accent = "brand", testid, to
}) {
  const accentMap = {
    brand: "text-[hsl(var(--brand))] bg-[hsl(var(--brand-light))]",
    info: "text-[hsl(var(--info-text))] bg-[hsl(var(--info-bg))]",
    warning: "text-[hsl(var(--warning-text))] bg-[hsl(var(--warning-bg))]",
    success: "text-[hsl(var(--success-text))] bg-[hsl(var(--success-bg))]",
    danger: "text-[hsl(var(--danger-text))] bg-[hsl(var(--danger-bg))]",
  };
  const cls = accentMap[accent] || accentMap.brand;
  const trendUp = typeof trend === "number" && trend >= 0;

  const content = (
    <div className="flex items-start justify-between gap-3">
      <div className="space-y-1.5 min-w-0">
        <div className="ds-overline truncate">{label}</div>
        <div
          className="text-3xl font-semibold leading-none tracking-tight"
          style={{fontFamily:"'Outfit',sans-serif"}}
        >
          {value}
        </div>
        {hint && (
          <div className="text-xs text-[hsl(var(--text-tertiary))] mt-1">{hint}</div>
        )}
      </div>
      {Icon && (
        <div className={`shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${cls}`}>
          <Icon className="w-5 h-5" />
        </div>
      )}
    </div>
  );

  const trendSection = typeof trend === "number" && (
    <div className={`mt-4 inline-flex items-center gap-1 text-xs font-medium ${
      trendUp ? "text-[hsl(var(--success-text))]" : "text-[hsl(var(--danger-text))]"
    }`}>
      {trendUp ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}
      {trendUp ? "+" : ""}{trend}% últimos 30 dias
    </div>
  );

  const containerClasses = `ds-card ds-card-hover p-5 transition-all duration-200 block ${
    to ? "hover:scale-[1.02] active:scale-[0.99] cursor-pointer hover:border-[hsl(var(--brand-light))]" : ""
  }`;

  if (to) {
    return (
      <Link to={to} className={containerClasses} data-testid={testid}>
        {content}
        {trendSection}
      </Link>
    );
  }

  return (
    <div className={containerClasses} data-testid={testid}>
      {content}
      {trendSection}
    </div>
  );
}
